<template>
  <v-card flat class="container--fluid pb-8">
    <v-card flat class="container--fluid bg-gray no-margins elevation-1 not-rounded">
      <v-card flat class="v-card__container">
        <v-card-title class="no-margins">
          <v-col>
            <h4>Företag</h4>

            <v-switch
              v-model="listCompanyWithoutEmployments"
              label="Visa enbart företag utan anställda"
            ></v-switch>

          </v-col>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            clearable
            prepend-icon="$sl-search"
            placeholder="Sök i listan"
            hide-details
            @keydown.enter="doSearch()"
          ></v-text-field>
        </v-card-title>        
      </v-card>
    </v-card>

    <v-data-table
      :headers="[{text: 'Företagsnamn', value: 'name'},{text: 'Org.nr.', value: 'organizationalNumber'},{text: 'Avtalstyp', value: 'contracttype.name'},{text: 'Adress', value: 'postalAddress1'},{text: 'Postnr', value: 'postalZip'},{text: 'Ort', value: 'postalCity'},{text: 'Stat.', value: 'isActive'}]"
      :items="companies"
      :loading="isLoading"
      :options.sync="options"
      :server-items-length="totalRows"
      :items-per-page="itemsPerPage"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        disableItemsPerPage: true,
      }"
      item-key="id"
      class="mt-6 clickable mx-6"
      @click:row="showCompany"
    >
      <!-- company name header -->
      <template slot="item.name" slot-scope="props">
        <div :class="[props.item.isActive ? '' : 'isInActiveBlack']" style="min-width: 160px;">{{ props.item.name }}</div>
      </template>
      <!-- company organizationalNumber header -->
      <template slot="item.organizationalNumber" slot-scope="props">
        <div :class="[props.item.isActive ? '' : 'isInActiveBlack']" style="min-width: 115px;">
          <CopyToClipboard :text="props.item.organizationalNumber">
            {{ props.item.organizationalNumber }}
          </CopyToClipboard>
        </div>
      </template>
      <!-- company contracttype.name -->
      <template slot="item.contracttype.name" slot-scope="props">
        <div :class="[props.item.isActive ? '' : 'isInActiveBlack']" style="min-width: 140px;">{{ (props.item.contracttype && props.item.contracttype.name) ? props.item.contracttype.name : '' }}</div>
      </template>
      <!-- company address-->
      <template slot="item.postalAddress1" slot-scope="props">
        <div :class="[props.item.isActive ? '' : 'isInActiveBlack']" style="min-width: 115px;">{{ props.item.postalAddress1 }}</div>
      </template>
      <template slot="item.postalZip" slot-scope="props">
        <div :class="[props.item.isActive ? '' : 'isInActiveBlack']" style="min-width: 120px;">{{ props.item.postalZip | formatZip }}</div>
      </template>
      <!-- company postalCity header -->
      <template slot="item.postalCity" slot-scope="props">
        <div :class="[props.item.isActive ? '' : 'isInActiveBlack']" style="min-width: 100px;">{{ props.item.postalCity }}</div>
      </template>
      <template slot="item.isActive" slot-scope="props">
        <div  style="width: 100px;">
          <v-icon>{{ props.item.isActive ? '$sl-athletics-team-running':'$sl-smiley-sleepy' }}</v-icon>
        </div>
      </template>
    </v-data-table>
     <v-row no-gutters class="my-4">
      <v-spacer></v-spacer>
      <v-col cols="12" lg="4" class="text-right mt-2">
        <p class="caption">Överstrukna företag är inaktiva.</p>
      </v-col>
    </v-row>
    <v-btn absolute bottom right fab class="v-btn--add-on-list" @click="newModal = true" :disabled="!canCreate">
      <v-icon class="ml-1">$sl-add</v-icon>
    </v-btn>
    <v-dialog v-model="newModal" max-width="600px">
      <CompanyNewModal
        @close="newModal = false"
        @manual="addCompanyManual"
        @company="addCompanyBolaget"
      />
    </v-dialog>
  </v-card>
</template>
<script>
import API from '@/services/api.js'
import {Criterias, CanIDo} from '@/components/mixins'
import {mapGetters, mapActions} from 'vuex'
import {pageSize} from '@/store/constants'
import CompanyNewModal from '@/components/company/CompanyNewModal'
import CopyToClipboard from '@/components/common/CopyToClipboard'

// @group Company
// Companies component
export default {
  name: 'Companies',

  mixins: [Criterias, CanIDo],

  components: {
    CompanyNewModal,
    CopyToClipboard,
  },

  data() {
    return {
      listCompanyWithoutEmployments: false,
      companies: [],
      search: '',
      newModal: false,
      options: {},
      itemsPerPage: pageSize,
      totalRows: 0,
      //- For fragment criterias
      criteria: {},
      doneInitialSearch: false
    }
  },
  watch: {
    options: {
      handler() {
        if ( this.listCompanyWithoutEmployments )
          this.fetchCompanies('widgetListCompanies')
        else this.fetchCompanies()
      },
      deep: true
    },
    listCompanyWithoutEmployments: {
      handler(val) {
        if ( val )
          this.fetchCompanies('widgetListCompanies')
        else this.fetchCompanies()
      }
    }
  },

  created() {
    console.log('Companies list - created')
    // @vuese
    //- Get criteria from url hash fragment
    const locationCriteria = this.getCriteriaFromLocation('c')
    // @vuese
    //- Set values if we have a criteria
    if (locationCriteria) {
      this.criteria = locationCriteria
      this.search = this.criteria.search
      this.listCompanyWithoutEmployments = this.criteria.listCompanyWithoutEmployments
      this.options = {
        page: this.criteria.page,
        itemsPerPage: this.criteria.pageSize,
        sortBy: [this.criteria.sortBy],
        sortDesc: [this.criteria.sortDesc]
      }
    }
  },

  computed: {
    ...mapGetters('app', ['isLoading'])
  },

  asyncComputed: {
    canCreate(){
      return this.canIDo('company', 'create');
    },
  },

  methods: {
    ...mapActions('company', ['setSelectedCompany']),
    doSearch() {
      if (this.options.page > 1) {
        this.options.page = 1
      } else {
        if ( this.listCompanyWithoutEmployments )
          this.fetchCompanies('widgetListCompanies')
        else this.fetchCompanies()
      }
    },

    // @vuese
    // Used to fetch person list
    // @arg The argument is object representing search criteries
    fetchCompanies(apiMethod = 'listCompanies') {
      const {sortBy, sortDesc, page, itemsPerPage} = this.options
      const startAt = (page - 1) * this.itemsPerPage

      this.criteria = {
        page: page,
        startAt: startAt ? startAt : 0,
        sortBy: sortBy ? sortBy[0] : 'lastName',
        sortDesc: sortDesc ? sortDesc[0] : 'ASC',
        search: this.search,
        pageSize: this.itemsPerPage,
        listCompanyWithoutEmployments: this.listCompanyWithoutEmployments
      }
      // @vuese
      //--Get the person list
      API[apiMethod](this.criteria)
        .then(response => {
          // @vuese
          //- Set fragment criteria
          this.setCriteriaToLocation('c', this.criteria)
          this.companies = response.data.rows
          this.totalRows = response.data.count
      
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },

    /**
     * @vuese
     * Used to push in the compani details
     * @arg The argument is a id value representing the id of the specific company
     */
    async showCompany(item) {
      // Clear previous one
      await this.setSelectedCompany(null)

      this.$nextTick(() =>
        this.$router.push({name: 'Company', params: {id: item.id}}).catch(() => {})
      )
    },

    /**
     * @vuese
     * Used to push in create new compani
     * @arg The param is the link that push to the form
     */
    addCompanyManual() {
      this.newModal = false
      this.setSelectedCompany({
        name: null,
        organizationalNumber: null,
        contracttype: null,
        postalAddress1: null,
        postalAddress2: null,
        postalCity: null,
        postalCountry: 'SE',
        postalZip: null,
        regionId: null,
        isApproved: true,
        isActive: true
      })
      this.$nextTick(() => {
        this.$router.push({name: 'CompanyNew'}).catch(() => {})
      })
    },

    /**
     * @vuese
     * Used to set initialise values to an null fields
     * @arg The param is tan object representing company
     */
    addCompanyBolaget(company) {
      this.newModal = false
      company.isApproved = true
      company.isActive = true
      company.contracttype = null
      company.regionId = null
      company.email ? company.email : null
      this.setSelectedCompany(company)
      this.$nextTick(() => {
        this.$router.push({name: 'CompanyNew'}).catch(() => {})
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>